const APP_STATUS = {
  ready: 'ready',
  loading: 'loading',
  done: 'done',
}

const API = {
  basket: {
    add: '/ajax/addToBasket.php',
  }
}

export {
  APP_STATUS,
  API,
}